import React from "react";
import { useNavigate } from "react-router-dom";
import { FaLock, FaArrowLeft, FaSignInAlt } from "react-icons/fa";

function UnauthorizedPage() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: "calc(100vh - 68px)",
        display:        "flex",
        alignItems:     "center",
        justifyContent: "center",
        background:     "linear-gradient(135deg, #f8fafc 0%, #fef2f2 100%)",
        padding:        "2rem 1rem",
      }}
    >
      <div
        style={{
          width:        "100%",
          maxWidth:     460,
          background:   "#ffffff",
          borderRadius: 20,
          boxShadow:    "0 8px 40px rgba(0,0,0,0.09)",
          border:       "1.5px solid #f0f4f8",
          padding:      "3rem 2.5rem",
          textAlign:    "center",
        }}
      >
        {/* Icon */}
        <div
          style={{
            display:        "inline-flex",
            alignItems:     "center",
            justifyContent: "center",
            width:          72,
            height:         72,
            borderRadius:   "50%",
            background:     "rgba(237, 27, 36, 0.08)",
            marginBottom:   "1.5rem",
          }}
        >
          <FaLock size={28} color="#ed1b24" />
        </div>

        {/* Heading */}
        <h2
          style={{
            fontWeight:    800,
            fontSize:      "1.5rem",
            color:         "#1e293b",
            letterSpacing: "-0.03em",
            marginBottom:  "0.5rem",
          }}
        >
          Seller Access Only
        </h2>

        {/* Subtitle */}
        <p
          style={{
            fontSize:     "0.9375rem",
            color:        "#64748b",
            lineHeight:   1.6,
            marginBottom: "2rem",
          }}
        >
          You need a seller account to post ads and manage listings.
          <br />
          Log in or create a free account to get started.
        </p>

        {/* Actions */}
        <div className="d-flex align-items-center justify-content-center gap-3 flex-wrap">
          <button
            onClick={() => navigate(-1)}
            className="btn btn-outline-secondary px-4"
            style={{ borderRadius: "50rem", fontWeight: 600 }}
          >
            <FaArrowLeft size={13} style={{ marginRight: 6 }} />
            Go Back
          </button>
          <button
            onClick={() => navigate("/login")}
            className="btn btn-danger px-4"
            style={{ borderRadius: "50rem", fontWeight: 600 }}
          >
            <FaSignInAlt size={13} style={{ marginRight: 6 }} />
            Sign In
          </button>
        </div>

        {/* Register hint */}
        <p style={{ marginTop: "1.5rem", fontSize: "0.875rem", color: "#94a3b8" }}>
          Don't have an account?{" "}
          <span
            onClick={() => navigate("/registration")}
            style={{ color: "#ed1b24", fontWeight: 600, cursor: "pointer" }}
          >
            Register for free
          </span>
        </p>
      </div>
    </div>
  );
}

export default UnauthorizedPage;
